
import { App, AppInfo } from '@capacitor/app';
import { Vue, Component } from 'vue-property-decorator';

@Component
export default class EnvironmentBanner extends Vue {
  appInfo : AppInfo | null = null;

  async mounted() {
    if(this.$q.platform.is.mobile){
      this.appInfo = await App.getInfo();
    }    
  }

  get environment() : string{
    let environment = process.env.ENVIRONMENT?.toString().toUpperCase();

    if(this.$q.platform.is.mobile && this.appInfo && environment){
      environment = `${environment} ${this.appInfo.version} (${this.appInfo.build})`;
    }

    console.log(environment);

    return <string>environment;
  } 

  get isProd(): boolean | undefined {
    return process.env.ENVIRONMENT?.includes('prod');
  }
}
